const o=()=>{};export{o as noop};
//# sourceMappingURL=index.js.map
